import Tooltip from '@components/Tooltips/Tooltip';
import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 30px;
  min-height: 300px;

  ${mq(Devices.laptop)} {
    padding-top: 10px;
  }

  ${mq(Devices.mobile)} {
    padding-top: 10px;
  }
`;

export const GridWrapper = styled.div<{ reverseCol?: boolean; setMinHeight?: boolean }>`
  position: relative;
  display: grid;
  grid-auto-flow: dense;
  grid-template-columns: repeat(4, calc(25% - 23px));
  gap: 30px;
  padding-bottom: 50px;
  min-height: ${(props) => (props.setMinHeight ? '70vh' : 'unset')};

  ${mq(Devices.tablet)} {
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  ${mq(Devices.mobile)} {
    grid-template-columns: 1fr;
    gap: 20px 0;
  }
`;

export const GridCard = styled.div<{
  col?: number;
  background?: string;
  heightAuto?: boolean;
  position?: string;
  scroll?: boolean;
  padding?: string;
  overflowHidden?:boolean;
  mobileHeight?:boolean;
  heightFix?:boolean;
}>`
  padding: ${(props) => (props.scroll ? '20px 10px 20px 20px' : props.padding ? props.padding : '20px')};
  background: ${(props) => (props.background ? props.background : '#fff')};
  grid-column: ${(props) => (props.col === 4 ? 'auto / span 4' : props.col === 2 ? 'auto / span 2' : 'unset')};
  border-radius: 10px;
  height:${(props) => (props.heightFix ? 'unset' : "100%")};
  min-height: ${(props) => (props.heightAuto ? 'unset' : props.heightAuto)};
  aspect-ratio: ${(props) => (props.heightAuto || props.heightFix ? "unset" : props.col === 2 ?'2.08 / 1.3' : '1 / 1.3')};
  position: relative;
  overflow: ${(props) => (props.overflowHidden ? 'hidden' : 'visible')};

  ${mq(Devices.laptop)} {
    grid-column: ${(props) => (props.col >= 2 ? 'auto / span 4' : 'auto / span 2')};
  }

  ${mq(Devices.tablet)} {
    padding: ${(props) => (props.scroll ? '10px 6px 10px 10px' : props.padding ? props.padding : '15px')};
    grid-column: ${(props) => (props.col >= 2 ? 'auto / span 2' : 'unset')};
    height: 100%;
    aspect-ratio: ${(props) => (props.heightAuto ? "unset" : props.mobileHeight?"unset": '1 / 1.2')};
  }

  ${mq(Devices.mobile)} {
    padding: ${(props) => (props.scroll ? '15px' : props.padding ? props.padding : '15px')};
    width:calc(100vw - 10px);
    height: 100%;
    grid-column: 1;
    min-height: ${(props) => (props.heightAuto ? 'unset' : props.mobileHeight?"unset": props.heightAuto)};
    aspect-ratio: ${(props) => (props.heightAuto ? "unset" : props.mobileHeight?"unset": '1 / 1.2')};
  }
`;

export const CardTitle = styled.span<{ titleColor?: string }>`
  display: flex;
  font-size: 22px;
  font-weight: 600;
  color: ${(props) => (props.titleColor ? props.titleColor : '')};

  ${mq(Devices.mobile)} {
    font-size: 6vw;
    line-height: 6vw;
  }
`;

export const CardToolTip = styled(Tooltip)<{ titleColor?: string }>`
  margin-left: 10px;
  display: flex;
  align-items: center;

  svg {
    width: 20px;
    path {
      fill: #5f5f5f;
    }
  }
`;

export const CardFocusTitle = styled.span`
  display: block;
  font-size: 20px;
  font-weight: 600;
  color: #fa505e;
  padding: 15px 0;
  text-align: center;

  ${mq(Devices.laptop)} {
    padding: 5px 0;
  }

  ${mq(Devices.mobile)} {
  }
`;

export const SysMsg = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: ${(props) => props.theme.colors.red};
  font-weight: 500;
  height: 100%;
`;
